module.exports = "/img/story-3.bc197284.png";